import React, { useEffect } from 'react';
import './ProjectsSection.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { projects } from '../data/projects';
import { useLanguage } from '../hooks/useLanguage';

const ProjectsSection = () => {
  const { t } = useLanguage();

  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <section className="projects" id="projects" data-aos="fade-up">
      <div className="projects-content">
        <h2 className="section-heading" data-aos="flip-left">{t.projects.title}</h2>
        <div className="projects-grid">
          {projects.map((project) => {
            const copy = t.projects[project.id];
            return (
              <div key={project.id} className="project-card">
                <img src={project.image} alt={copy.name} className="project-thumbnail" />
                <div className="project-info">
                  <h3>{copy.name}</h3>
                  <p>{copy.description}</p>
                  <div className="project-tags" aria-label="Project type">
                    {project.tags.map((tag) => (
                      <span key={tag} className="project-tag">{t.tags[tag]}</span>
                    ))}
                  </div>
                  <div className="project-details visible">
                    <p>
                      <strong>{t.projects.technologiesLabel}:</strong>
                      {' '}
                      {project.technologies.join(', ')}
                    </p>
                    <a href={project.link} target="_blank" rel="noopener noreferrer">
                      {t.projects.viewProject}
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
